module.exports = __webpack_public_path__ + "img/selected4-min.330931c0.png";